import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { SmallNavigation } from 'console/navigation/small';
import { MediumNavigationTabs } from 'console/navigation/components/navigation-tabs/medium';
import { TabContext } from 'console/navigation/context/type';
import CameraDialog from 'console/tabs/legacy/camera-dialog/cameradialog';
import { isAvailablePhotos } from 'entities/device.photos/model/get-photos-actions';
import { is_dashboard_selected } from 'console/dashboards/z3k/selectors';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { Hide } from 'console/shared/components/utils';
import { useKeybind } from 'console/navigation/model/use-keybind';
export const Navigation = memo(function NavigationImpl() {
    const { device, legacy_device, account_id, selected_tab, ui, selectTabKey, shown_tabs, } = useContext(TabContext);
    const dashboard_selected = useAppSelector(is_dashboard_selected);
    const onOpenCameraDialog = useCallback(() => CameraDialog.instance().open(ui, legacy_device), [ui, legacy_device]);
    const cameraButtonSpec = useMemo(() => ({
        key: 'camera',
        title: 'Камера',
        iconclass: 'ui-icon-tab-camera',
        onClick: onOpenCameraDialog,
        selected: false,
    }), [onOpenCameraDialog]);
    const buttons = useMemo(() => Array.from((function* () {
        if (isAvailablePhotos(account_id, device))
            yield cameraButtonSpec;
    })()), [account_id, device, onOpenCameraDialog, cameraButtonSpec]);
    const handles = useMemo(() => [
        ...shown_tabs.map((tabDef) => ({
            key: tabDef.key,
            title: typeof tabDef.title === 'string'
                ? tabDef.title
                : tabDef.title(device?.device_type),
            iconclass: typeof tabDef.iconclass === 'string'
                ? tabDef.iconclass
                : tabDef.iconclass(device?.device_type),
            icon: tabDef.icon,
            onClick: () => selectTabKey(tabDef.key),
            selected: tabDef == selected_tab,
            data_tooltip: tabDef.data_tooltip,
        })),
        ...buttons,
    ], [shown_tabs, selectTabKey, selected_tab, buttons, device?.device_type]);
    const NavigationComponent = isSmallUI() ? SmallNavigation : MediumNavigationTabs;
    useKeybind(shown_tabs, selected_tab);
    return (_jsx(Hide, { when: device == null || legacy_device == null || dashboard_selected, children: _jsx(NavigationComponent, { handles: handles }) }));
});
